/**
 * Token Packs Configuration
 * 
 * This file contains the Stripe Price IDs for each token pack.
 * Update these when you need to change pricing or use different Stripe products.
 */

export const TOKEN_PACKS = {
  starter: {
    tokens: 10,
    priceId: 'price_1STsNBH9z0ThRFdKi95VZtqK', // Starter Token Pack
    label: 'Starter Pack',
    amount: 4.99 // $4.99 in dollars
  },
  popular: {
    tokens: 25,
    priceId: 'price_1STsOKH9z0ThRFdKUiarHmRE', // Popular Token Pack
    label: 'Popular Pack',
    amount: 9.99 // $9.99 in dollars
  },
  value: {
    tokens: 50,
    priceId: 'price_1STsVeH9z0ThRFdKIbMPl0fP', // Value Pack
    label: 'Value Pack',
    amount: 17.99 // $17.99 in dollars
  }
};

/**
 * Helper function to get a token pack by price ID
 * @param {string} priceId - The Stripe Price ID
 * @returns {Object|null} - The token pack object or null if not found
 */
export const getTokenPackByPriceId = (priceId) => {
  return Object.values(TOKEN_PACKS).find(pack => pack.priceId === priceId) || null;
};

/**
 * Helper function to get token pack by key
 * @param {string} key - The pack key ('starter', 'popular', 'value')
 * @returns {Object|null} - The token pack object or null if not found
 */
export const getTokenPack = (key) => {
  return TOKEN_PACKS[key] || null;
};

